module.exports = __webpack_public_path__ + "img/activation-type-actived.4e7e93df.svg";